"use client";

import { Tooltip as ReactTooltip } from "react-tooltip";
import { ReactNode } from "react";
import { createPortal } from "react-dom";

interface TooltipProps {
  id: string;
  content: string | ReactNode;
  children: ReactNode;
  place?: "top" | "right" | "bottom" | "left";
  className?: string;
  delayShow?: number;
  delayHide?: number;
  variant?: "light" | "dark";
}

const Tooltip = ({
  id,
  content,
  children,
  place = "top",
  className = "",
  delayShow = 200,
  delayHide = 200,
  variant = "dark"
}: TooltipProps) => {
  return (
    <>
      <div data-tooltip-id={id} className={className}>
        {children}
      </div>
      {typeof window !== "undefined" &&
        createPortal(
          <ReactTooltip
            id={id}
            place={place}
            render={() => content}
            delayShow={delayShow}
            delayHide={delayHide}
            variant={variant}
            style={{ maxWidth: "300px", zIndex: 102 }}
          />,
          document.body
        )}
    </>
  );
};

export default Tooltip;
